import {
  USER_ADJUST_CART_ITEM_LOADING,
  USER_ADJUST_CART_ITEM_SUCCESS,
  USER_ADJUST_CART_ITEM_FAILURE,
} from "redux/types";
import { Dispatch } from "redux";
import { createNewItemService } from "services/createNewItemService";
import { adjustCartItemUrl } from "api/apiUrls";
import { notification } from "antd";

export const userAdjustCartItemActions =
  (lang: any, userId: any, data?: any, callback?: any) =>
  async (dispatch: Dispatch) => {
    try {
      dispatch({ type: USER_ADJUST_CART_ITEM_LOADING, payload: true });

      const response: any = await createNewItemService(
        `${adjustCartItemUrl}${lang}/user/${userId}/add`,
        data,
        "",
        "json"
      );

      if (response.status !== 200) {
        notification.error({
          message: "Something went wrong!",
          description: "Please refresh!",
        });
      } else {
        callback();
      }

      dispatch({ type: USER_ADJUST_CART_ITEM_SUCCESS, payload: response.data });
    } catch (err) {
      dispatch({ type: USER_ADJUST_CART_ITEM_FAILURE, payload: err });
    } finally {
      dispatch({ type: USER_ADJUST_CART_ITEM_LOADING, payload: false });
    }
  };
